
  import auth from '../auth'
  import {mapGetters, mapActions} from 'vuex';
  import Alert from 'vux/src/components/alert/index.vue'
import Loading from 'vux/src/components/loading/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Sticky from 'vux/src/components/sticky/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'


  import echarts from 'echarts';
  import '../../node_modules/echarts/theme/vintage.js';

  const list = () => ['< 返回', '成交价格', '成交量', '户型分布']

  export default {
    components: {
      Alert,
      Loading,
      Tab,
      TabItem,
      Sticky,
      Divider,
      XButton,
      Swiper,
      SwiperItem
    },
    data () {
      return {
        show: false,
        show_title: '提示',
        show_content: '您的余额已不足，请充值后使用!',
        btn_ok: '确认',
        btn_cancel: '取消',
        show1: true,
        text1: '加载中',
        height: '',
        winW: '',
        winH: '',

        list2: list(),
        demo2: '成交价格',
        index: 1,
        openid: '',
        token: '',
        community: '',
        respData: {},
        reqApiDataUrl: null,
        chart: {}
      }
    },
    computed: {
      ...mapGetters({
          // 映射 this.webReqType 为 store.getters.webReqType
          webReqType: 'webReqType',
          scoins: 'coins'
      })
    },
    mounted() {
      if(typeof(this.$route.query.type)!= "undefined"){
        this.updateReqType(this.$route.query.type);
      }
      else{
        this.updateReqType('0');
      }
      let w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      let h = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      console.debug("document.w:%d, h:%o", this.winW, this.winH);
      this.winW = w + 'px';
      this.winH = h - 44 +'px';
      this.height = this.winH;
/*
      let vdom = document.getElementById('vswiper');
      console.debug("vdom>width:%o, height:%o", vdom.clientWidth, vdom.clientHeight);
      vdom.style.width = window.innerWidth+'px';
      vdom.style.height = window.innerHeight - 44 +'px';
      //this.height = vdom.style.height;
      console.debug("vdom>width:%o, height:%o, this.height:%o", vdom.style.width, vdom.style.height, this.height);
*/
      /*
      console.debug("innerWidth:%o, documentElement.clientWidth:%o, body.clientWidth:%o", window.innerWidth, document.documentElement.clientWidth, document.body.clientWidth);
      console.debug("innerHeight:%o, documentElement.clientHeight:%o, body.clientHeight:%o", window.innerHeight, document.documentElement.clientHeight, document.body.clientHeight);
      let w=window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      let h=window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      console.debug("document.w:%d, h:%o", w, h);
      this.height = h;
      console.debug("this.height:%o", this.height);
      */
      console.debug("scoins:%d", this.scoins);
      if(this.scoins < 1 && this.webReqType === '0'){
        this.show1 = false;
        this.showPluginAuto();
        return;
      }
      // console.log(">>>Detail Price state state:%o",this.$store.state)
      // console.log("created...")
      // console.log('get openid:%s', auth.getOpenid())
      // console.log('get token:%s', auth.getToken())
      // console.log("route.query.cm:%s",this.$route.query.cm)
      let cm = auth.getCm()
      let newcm = this.$route.query.cm
      // console.log("newcm:%s, cm:%s", newcm, cm)
      if(typeof(this.$route.query.cm)!= "undefined" && cm != newcm){
        // console.log("update new cm")
        auth.setCm(newcm)
        cm = newcm
      }

      this.community = cm
      // console.log("reqApiData")
      this.openid = auth.getOpenid()
      this.token = auth.getToken()
      this.reqApiData(this.openid, this.token, this.community)

      /*if(typeof(this.$route.query.type)!= "undefined"){
        this.webReqType = this.$route.query.type
        // console.log("webReqType:%s", this.webReqType)
        auth.setCmType(this.webReqType)
      }
      */
      if(this.webReqType === '3'){
        this.list2 = ['成交价格', '成交量', '户型分布']
      }
    },
    methods: {
      ...mapActions({
        // 映射 this.updateReqType() 为 this.$store.dispatch('updateReqType')
        updateReqType: 'updateReqType',
        updateReqCoin: 'updateReqCoin'
      }),
      onHide () {
        console.log('on hide')
        this.$router.push({ path: '/',query: { type: this.webReqType }});
      },
      onShow () {
        console.log('on show')
      },
      showPlugin () {
        this.show = true;
      },
      showPluginAuto () {
        this.showPlugin()
        setTimeout(() => {
          this.show = false;
          this.$router.push({ path: '/',query: { type: this.webReqType }});
        }, 3000)
      },
      barHandler: function(item){
        if(this.webReqType === '3'){
          return;
        }
        switch(item)
        {
          case this.list2[0]:
            // console.log("return home");
            this.$router.push({ path: '/',query: { type: this.webReqType }});
            break;
          case this.list2[1]:
            break;
          case this.list2[2]:
            break;
          default:
            break;
        }
      },
      drawbar(id, priceData, bjPriceData) {
        let idom = document.getElementById(id);
        //console.debug("drawLine> width:%o, height:%o", idom.style.width, idom.style.height);
        idom.style.width = this.winW; //window.innerWidth+'px';
        idom.style.height = this.winH; //window.innerHeight-44+'px';
        //console.debug("drawLine> width:%o, height:%o", idom.style.width, idom.style.height);

        this.chart = echarts.init(idom);

        this.chart.setOption({
          baseOption:{
            title: {
                text: '成交量',
                subtext: '数据来自链家'
            },
            tooltip: {
                trigger: 'axis'
            },
            legend: {
                orient: 'vertical',
                data:[priceData.name, '北京']
            },
            grid: {
                show: true,
                left: '1%',
                right: '1%',
                //bottom: '3%',
                containLabel: true
            },
            toolbox: {
                feature: {
                  dataView: {readOnly: false}
                }
            },
            yAxis: {
              type: 'category',
              inverse: true,
              boundaryGap: true,
              data: priceData.categories
            },
            xAxis : [
            {
              type: 'value',
              scale: true,
              position:'top',
              axisLine : {    // 轴线
                  show: true,
                  lineStyle: {
                      color: 'rgba(187,40,43,1)',
                      type: 'solid',
                      width: 2
                  }
              }
            },
            {
              type: 'value',
              scale: true,
              position:'bottom',
              axisLine : {    // 轴线
                  show: true,
                  lineStyle: {
                      color: 'rgba(41,61,76,1)',
                      type: 'solid',
                      width: 2
                  }
              }
            }
            ],
            series: [
              {
                name: priceData.name,
                type:'bar',
                xAxisIndex: 0,
                data: priceData.data
              },
              {
                  name:'北京',
                  type:'bar',
                  xAxisIndex: 1,
                  data: bjPriceData.data
              }
            ]
          },
           media: [
              {
                option: {
                  grid: {
                    show: true,
                    left: '1%',
                    right: '1%',
                    bottom: '1%',
                    containLabel: true
                  }
                }
              },
              {
                query: {
                    maxWidth: 100              // 当容器宽度小于 500 时。
                },
                option: {
                  grid: {
                    show: true,
                    left: '1%',
                    right: '1%',
                    bottom: '30%',
                    containLabel: true
                  }
                }
              }
          ]


        });
      },
      drawpie(id, centery, bedroom, bjbedroom) {
        console.log("id:%s, centery:%s, bedroom:%o, bjbedroom:%o", id, centery, bedroom, bjbedroom);
        let idom = document.getElementById(id);
        //console.debug("drawLine> width:%o, height:%o", idom.style.width, idom.style.height);
        idom.style.width = this.winW; //window.innerWidth+'px';
        idom.style.height = this.winH; //window.innerHeight-44+'px';
        //console.debug("drawLine> width:%o, height:%o", idom.style.width, idom.style.height);

        this.chart = echarts.init(idom);
        this.chart.setOption({

        baseOption: {
            title : {
                text: '户型分布',
                subtext: '数据来自链家'
                //x:'left'
            },
            tooltip : {
                trigger: 'item',
                formatter: "{a} <br/>{b} : {c} ({d}%)"
            },
            legend: {
                data: bedroom.categories
            },
            toolbox: {
                show : true,
                feature : {
                    mark : {show: true},
                    dataView : {show: true, readOnly: false},
                    magicType : {
                        show: true,
                        type: ['pie', 'funnel']
                    },
                    saveAsImage : {show: true}
                }
            },
            calculable : true,
            series : [
                {
                    name: bedroom.name,
                    type:'pie',
                    roseType : 'radius',
                    label: {
                        normal: {
                            show: true
                        },
                        emphasis: {
                            show: true
                        }
                    },
                    lableLine: {
                        normal: {
                            show: true
                        },
                        emphasis: {
                            show: true
                        }
                    },
                    data: bedroom.data
                },
                {
                    name: bjbedroom.name,
                    type:'pie',
                    roseType : 'area',
                    data: bjbedroom.data
                }
            ]
        },
        media: [
          {
              option: {
                  legend: {
                      left: 'left',
                      top: 'bottom',
                      orient: 'horizontal'
                  },
                  series: [
                      {
                          radius: ['10%', '30%'],
                          center: ['50%', '30%']
                      },
                      {
                          radius: ['10%', '30%'],
                          center: ['50%', '65%']
                      }
                  ]
              }
          }

        ]


        });
      },
      drawLine(id, linedata, bjlinedata) {
        // console.log("drawline> id:%s, linedata:%o, bjlinedata:%o", id, linedata, bjlinedata);
        let idom = document.getElementById(id);
        //console.debug("drawLine> width:%o, height:%o", idom.style.width, idom.style.height);
        idom.style.width = this.winW; //window.innerWidth+'px';
        idom.style.height = this.winH; //window.innerHeight-44+'px';
        //console.debug("drawLine> width:%o, height:%o", idom.style.width, idom.style.height);

        this.chart = echarts.init(idom);
        this.chart.setOption({

          baseOption:{
            title: {
              text: '成交价格',
              subtext: '数据来自链家'
            },
            tooltip: {
              trigger: 'axis'
            },
            legend: {
              orient: 'vertical',
              data:[linedata.name,'北京']
            },
            grid: {
              show: true,
              left: '1%',
              right: '1%',
              containLabel: true
            },
            toolbox: {
              feature: {
                dataView: {readOnly: false}
              }
            },
            xAxis: {
              type: 'value',
              scale: true,
              position:'top'
            },
            yAxis: {
              type: 'category',
              inverse: true,
              boundaryGap: true,
              data: linedata.categories
            },
            series: [
              {
                name: linedata.name,
                type:'line',
                data: linedata.data,
                markLine: {
                  data: [
                    {type: 'average', name: '平均值'}
                  ]
                }
              },
              {
                name:'北京',
                type:'line',
                data: bjlinedata.data
              }
            ]
          },
          media: [
            {
              option: {
                grid: {
                  show: true,
                  left: '1%',
                  right: '1%',
                  bottom: '1%',
                  containLabel: true
                }
              }
            },
            {
              query: {
                  maxWidth: 100              // 当容器宽度小于 500 时。
              },
              option: {
                grid: {
                  show: true,
                  left: '1%',
                  right: '1%',
                  bottom: '30%',
                  containLabel: true
                }
              }
            }
          ]

        });
      },
      transform(obj, name, type){
        // console.log("obj:%o, name:%s, type:%d", obj, name, type);
        let to = new Object();
        let at = [];
        let as = [];
        let key = '';
        let value = '';
        for(let item in obj){
          if(type === 1){
            key = obj[item]['bedroom'] + "居室"
            value = obj[item]['count']
            value = {value:value, name:key}
          }else{
            key = item
            value = obj[item]
          }
          at.push(key)
          as.push(value)
        }
        to.categories = at;
        to.data = as;
        to.name = name;
        return to;
      },
      load: function(data){
        // console.log("data:%o", data)
        if(typeof(data) === "undefined" || typeof(data.price) === "undefined"){
          console.error("input data error : " + data)
          return
        }
        // console.log("data:%o", data)

        let brief_name = this.community;
        let count = new Object();
        let bjcount = new Object();
        count = this.transform(data.count, brief_name, 0)// asyncData
        bjcount = this.transform(data.bj_count, '北京', 0)// bjasyncData
        // console.log("load...count:%o", count);
        // console.log("load...bjcount:%o", bjcount);
        this.drawbar('dealPrice', count, bjcount);

        let price = new Object();
        let bjprice = new Object();
        price = this.transform(data.price, brief_name, 0)// asyncData
        bjprice = this.transform(data.bj_price, '北京', 0)// bjasyncData
        // console.log("load...price:%o", price);
        // console.log("load...bjprice:%o", bjprice);
        this.drawLine('dealQty', price, bjprice);

        let bedroom = this.respData.bedroom
        let bj_bedroom = this.respData.bj_bedroom
        bedroom = this.transform(this.respData.bedroom, brief_name, 1)// asyncData
        bj_bedroom = this.transform(this.respData.bj_bedroom, '北京', 1)// bjasyncData
        // console.log("load...bedroom:%o", bedroom);
        // console.log("load...bj_bedroom:%o", bj_bedroom);
        this.drawpie('dealType', '60%', bedroom, bj_bedroom);

      },
      reqApiData: function(openid, token, community){
        // console.log("openid:%s, token:%s, community:%s", openid, token,community)
        let reqHouseAreaUrl = null
        let req_data = null
        console.log("webReqType:%s, typeof:%s", this.webReqType, typeof(this.webReqType))
        switch(this.webReqType){
          case '1':
            // console.log("bussiness deal")
            req_data = {openid:openid, token:token, bizcycle:community}
            reqHouseAreaUrl = 'http://alphago.chemucao.cn/real/api/index.php/bizcycle/deal'
            break;
          case '2':
            // console.log("district deal")
            req_data = {openid:openid, token:token, district:community}
            reqHouseAreaUrl = 'http://alphago.chemucao.cn/real/api/index.php/district/deal'
            break;
          case '3':
            // console.log("city deal")
            req_data = {openid:openid, token:token, city:community}
            reqHouseAreaUrl = 'http://alphago.chemucao.cn/real/api/index.php/city/deal'
            break;
          case '0':
          default:
            // console.log("nearby deal")
            req_data = {openid:openid, token:token, community:community}
            reqHouseAreaUrl = 'http://alphago.chemucao.cn/real/api/index.php/community/deal'
            break;
        }
        var url = reqHouseAreaUrl
        // console.log("reqHouseArea url:%s", url);
        this.$http.post(url, req_data).then((response) => {
          // console.log("PASS! response:%o", response);
          // console.log("status:%s", response.status);
          // console.log("statusText:%s", response.statusText);
          // console.log("Expires: %s", response.headers.get('Expires'));
          // console.log("body: %o", response.body);
          this.respData = response.body.data
          console.log("webReqType:%d, data:%o", this.webReqType, response.body.data)
          if(this.webReqType === '0') {
            console.log("scoins: %d", response.body.data.coin)
            auth.setCoins(response.body.data.coin)
            this.updateReqCoin(response.body.data.coin);
          }
          this.load(this.respData)
          this.show1 = false;
        }, (response) => {
          console.error("FAIL!!! response:%o", response);
        });
      }
    }
  }



// WEBPACK FOOTER //
// ./src/components/DetailTest.vue